import React from 'react';
import { ProductFeaturesSlider } from 'Components/widgets/product-features-slider/ProductFeaturesSlider';
import { ProductInformation } from 'Components/widgets/product-information/ProductInformation';
import type { ProductFeatureCardProps } from 'Components/widgets/product-feature-card/ProductFeatureCard';
import 'Components/widgets/product-feature-card/ProductFeatureCard';
import type { IntroductionProps } from 'Components/frameworks/introduction/Introduction';
import 'Components/frameworks/introduction/Introduction';
export type ProductFeaturesCategoryProps = {
  activities: Array<ProductFeatureCardProps>;
  backNavigationLabel?: string;
  errorMessage?: string;
  id: string;
  title: string;
};
type ProductFeaturesProps = {
  categories: Array<ProductFeaturesCategoryProps>;
  introduction?: IntroductionProps;
  labelGAPrefix: string;
  queryLayer: string;
  renderDetail: (data: any) => Node;
  scrollBackwardLabel?: string;
  scrollForwardLabel?: string;
};

const getItems = ({
  categories,
  labelGAPrefix,
  queryLayer,
  renderDetail,
  scrollBackwardLabel,
  scrollForwardLabel,
}) =>
  (categories || []).map((category, index) => ({
    header: {
      title: category.title,
      trackingData: {
        categoryGA: 'resort',
        actionGA: 'blockInfos',
        labelGA: `${labelGAPrefix}_${category.id}`,
      },
    },
    content: [
      <ProductFeaturesSlider
        backNavigationLabel={category.backNavigationLabel}
        errorMessage={category.errorMessage}
        items={category.activities}
        key={category.id}
        queryLayer={queryLayer}
        renderDetail={renderDetail}
        scrollBackwardLabel={scrollBackwardLabel}
        scrollForwardLabel={scrollForwardLabel}
        sliderIndex={index}
      />,
    ],
  }));

export const ProductFeatures = ({
  categories,
  introduction,
  labelGAPrefix,
  queryLayer = 'productActivitiesLayer',
  renderDetail,
  scrollBackwardLabel,
  scrollForwardLabel,
}: ProductFeaturesProps) => (
  <ProductInformation
    introduction={introduction}
    items={getItems({
      categories,
      labelGAPrefix,
      queryLayer,
      renderDetail,
      scrollBackwardLabel,
      scrollForwardLabel,
    })}
    queryLayer={queryLayer}
    scrollBackwardLabel={scrollBackwardLabel}
    scrollForwardLabel={scrollForwardLabel}
  />
);
